export default [
	{
		cellsalign: null,
		cellsformat: null,
		columntype: null,
		datafield: 'VendorNumber',
		displayfield: null,
		filtercondition: null,
		filterdelay: 0,
		filterlist: null,
		filtertype: null,
		formatter: null,
		originalwidth: 65,
		text: 'Vendor#',
		width: null
	},
	{
		cellsalign: null,
		cellsformat: null,
		columntype: null,
		datafield: 'VendorName',
		displayfield: null,
		filtercondition: null,
		filterdelay: 0,
		filterlist: null,
		filtertype: null,
		formatter: null,
		originalwidth: 250,
		text: 'Vendor Name',
		width: null
	},
	{
		cellsalign: null,
		cellsformat: 'N0',
		columntype: null,
		datafield: 'CompanyId',
		displayfield: null,
		filtercondition: null,
		filterdelay: 0,
		filterlist: null,
		filtertype: 'number',
		formatter: null,
		originalwidth: 80,
		text: 'Company Id',
		width: null
	},
	{
		cellsalign: null,
		cellsformat: 'N0',
		columntype: null,
		datafield: 'BatchNumber',
		displayfield: null,
		filtercondition: null,
		filterdelay: 0,
		filterlist: null,
		filtertype: 'number',
		formatter: null,
		originalwidth: 70,
		text: 'Batch#',
		width: null
	},
	{
		cellsalign: null,
		cellsformat: 'C2',
		columntype: null,
		datafield: 'Amount',
		displayfield: null,
		filtercondition: null,
		filterdelay: 0,
		filterlist: null,
		filtertype: 'number',
		formatter: null,
		originalwidth: 100,
		text: 'Amount',
		width: null
	},
	{
		cellsalign: null,
		cellsformat: null,
		columntype: null,
		datafield: 'Description',
		displayfield: null,
		filtercondition: null,
		filterdelay: 0,
		filterlist: null,
		filtertype: null,
		formatter: null,
		originalwidth: 250,
		text: 'Description',
		width: null
	}
];
